import { StockApiClient } from '@fourthwall/services/dist/StockApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const updateStockMutationKey = 'updateStock'

export const useUpdateStockMutation = createMutationHook(StockApiClient.updateStock, {
  mutationKey: ['updateStock'],
})
